module.exports = __webpack_public_path__ + "static/WEDDING E&M-588-98dfd45f54e7e15831a8803eebb7f3f0.jpg";